<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar">
    <!-- Menu -->
    <div class="menu">
      <ng-scrollbar [style.height]="listMaxHeight + 'px'" visibility="hover">
        <ul class="list">
          <!-- Enterprise Period Component -->
          <li class="sidebar-user-panel">
            <enterprise-period></enterprise-period>
          </li>
          <!-- Top Most level menu -->
          @for (sidebarItem of sidebarItems; track sidebarItem; let i = $index) {
            <li
              [class.section-collapsed]="!sidebarItem.groupTitle && isItemInSection(i)"
              [routerLinkActive]="sidebarItem.submenu.length !== 0 ? 'active' : 'active-top'"
              (mouseenter)="onMenuItemHover($event, sidebarItem, i)"
              (mouseleave)="onMenuItemLeave()">
              @if (sidebarItem.groupTitle === true) {
                <div class="header section-header" (click)="toggleSection(sidebarItem.title)">
                  <span>{{sidebarItem.title | translate}}</span>
                  <i-feather
                    [name]="isSectionCollapsed(sidebarItem.title) ? 'chevron-right' : 'chevron-down'"
                    class="section-chevron">
                  </i-feather>
                </div>
              }
              @if (!sidebarItem.groupTitle;) {
                <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
                  [ngClass]="[sidebarItem.class]" (click)="callToggleMenu($event, sidebarItem.submenu.length)"
                  class="menu-top"
                  [matTooltip]="getTooltipText(sidebarItem)"
                  [matTooltipDisabled]="!shouldShowTooltip(sidebarItem)"
                  matTooltipPosition="right">
                  <i-feather [name]="sidebarItem.icon" class="sidebarIcon"></i-feather>
                  <span class="hide-menu">{{sidebarItem.title | translate}}
                  </span>
                  @if (sidebarItem.badge !== '' ) {
                    <span [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
                  }
                </a>
              }
              <!-- First level menu -->
              @if (sidebarItem.submenu.length > 0) {
                <ul class="ml-menu">
                  @for (sidebarSubItem1 of sidebarItem.submenu; track sidebarSubItem1) {
                    @if (sidebarSubItem1.separator) {
                      <li class="menu-separator"></li>
                    } @else {
                    <li
                      [routerLinkActive]="sidebarSubItem1.submenu.length > 0 ? '' : 'active'">
                      <a [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : [sidebarSubItem1.path]"
                        (click)="callToggleMenu($event,sidebarSubItem1.submenu.length)" [ngClass]="[sidebarSubItem1.class]">
                        {{sidebarSubItem1.title | translate}}
                      </a>
                      <!-- Second level menu -->
                      @if (sidebarSubItem1.submenu.length > 0) {
                        <ul class="ml-menu-2">
                          @for (sidebarSubItem2 of sidebarSubItem1.submenu; track sidebarSubItem2) {
                            <li
                              [routerLinkActive]="sidebarSubItem2.submenu.length > 0 ? '' : 'active'">
                              <a [routerLink]="sidebarSubItem2.submenu.length > 0 ? null : [sidebarSubItem2.path]"
                                (click)="callToggleMenu($event,sidebarSubItem2.submenu.length)"
                                [ngClass]="[sidebarSubItem2.class]">
                                {{sidebarSubItem2.title | translate}}
                              </a>
                              <!-- Third level menu -->
                              @if (sidebarSubItem2.submenu.length > 0) {
                                <ul class="ml-menu-3">
                                  @for (sidebarSubItem3 of sidebarSubItem2.submenu; track sidebarSubItem3) {
                                    <li
                                      [routerLinkActive]="sidebarSubItem3.submenu.length > 0 ? '' : 'active'">
                                      <a [routerLink]="sidebarSubItem3.submenu.length > 0 ? null : [sidebarSubItem3.path]"
                                        (click)="callToggleMenu($event,sidebarSubItem3.submenu.length)"
                                        [ngClass]="[sidebarSubItem3.class]">
                                        {{sidebarSubItem3.title | translate}}
                                      </a>
                                    </li>
                                  }
                                </ul>
                              }
                            </li>
                          }
                        </ul>
                      }
                    </li>
                    }
                  }
                </ul>
              }
            </li>
          }
          <li class="logout-item" (mouseenter)="checkCollapsedState()">
            <a class="" (click)="logout()" class="menu-top"
              [matTooltip]="'GENERALITEMS.AUTH.LOGOUT' | translate"
              [matTooltipDisabled]="!isCollapsed"
              matTooltipPosition="right">
              <i-feather name="log-out" class="sidebarIcon"></i-feather>
              <span class="hide-menu">{{'GENERALITEMS.AUTH.LOGOUT' | translate}}
              </span>
            </a>
          </li>
        </ul>
      </ng-scrollbar>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
  
  <!-- Flyout Submenu (aparece ao lado quando sidebar colapsado) -->
  @if (showFlyout && flyoutItem && isCollapsed) {
    <div class="submenu-flyout" 
         [style.top.px]="flyoutTop"
         (mouseenter)="keepFlyoutOpen()"
         (mouseleave)="closeFlyout()">
      <div class="flyout-header">{{flyoutItem.title | translate}}</div>
      <ul class="flyout-menu">
        @for (subItem of flyoutItem.submenu; track subItem) {
          @if (subItem.separator) {
            <li class="menu-separator"></li>
          } @else {
            <li [routerLinkActive]="'active'">
              <a [routerLink]="[subItem.path]" (click)="closeFlyout()">
                {{subItem.title | translate}}
              </a>
            </li>
          }
        }
      </ul>
    </div>
  }
</div>
